const PIXEL_ID = '1263013442350625'

let initialized = false

export function initPixel() {
  if (initialized) return
  if (typeof window === 'undefined') return

  const w = window as any

  if (w.fbq) return

  const n: any = (w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  w.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackPageView() {
  const w = window as any
  if (w.fbq) {
    w.fbq('track', 'PageView')
  }
}

export function trackAddToCart() {
  const w = window as any
  if (w.fbq) {
    w.fbq('track', 'AddToCart', {
      content_name: 'Protocolo Noche Tranquila 65+',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
